<section class="sen-fs10 position-relative">
    <h4 class="p-2 pl-4 text-white" mat-dialog-title>
        &nbsp;{{ translate.getLng("SELECT_PANEL") }}
        <span class="sen-fs12" *ngIf="projectModulname"
            >({{ translate.getLng("PROJECT_PANEL") }}:
            {{ projectModulname }})</span
        >
    </h4>
    <mat-tab-group
        animationDuration="0ms"
        [(selectedIndex)]="defaultTab"
        class="sen-submenu-color"
    >
        <mat-tab label="{{ translate.getLng('SEN') }}" class="px-2">
            <ng-template matTabContent>
                <sen-app-sen-panel
                    [validateForm]="validateForm"
                    (sPanel)="getSelectedPanel($event)"
                    (selectedPanelEmit)="senPanelValid = $event"
                >
                </sen-app-sen-panel>
            </ng-template>
        </mat-tab>
        <mat-tab label="{{ translate.getLng('MOD_OWN') }}" class="px-2">
            <ng-template matTabContent>
                <sen-app-own-panel
                    (sPanel)="getSelectedPanel($event)"
                    [validateForm]="validateForm"
                    (formStatus)="ownPanelValid = $event"
                >
                </sen-app-own-panel>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
    <hr class="m-0" />
    <table class="w-100">
        <tr>
            <td>
                <b>{{ translate.getLng("DIRECTION") }}</b>
            </td>
            <td>
                <mat-radio-group [(ngModel)]="panelDirection">
                    <mat-radio-button
                        [disabled]="checkPanelOrientation()"
                        [value]="panelDirectionValues.ORIENTATION_VERTICAL"
                        class="mr-3"
                    >
                        {{ translate.getLng("PORTRAIT") }}
                    </mat-radio-button>
                    <mat-radio-button
                        [value]="panelDirectionValues.ORIENTATION_HORIZONTAL"
                    >
                        {{ translate.getLng("LANDSCAPE") }}
                    </mat-radio-button>
                </mat-radio-group>
            </td>
        </tr>
        <tr *ngIf="!panelFillAll">
            <td>
                <b>{{ translate.getLng("PNL_FILL_AUTO") }}</b>
            </td>
            <td>
                <mat-radio-group [(ngModel)]="panelFill">
                    <mat-radio-button
                        [value]="panelFillValues.ALL"
                        class="mr-3"
                    >
                        {{ translate.getLng("PNL_FILL_FULL") }}
                    </mat-radio-button>
                    <mat-radio-button [value]="panelFillValues.INNER">
                        {{ translate.getLng("PNL_FILL_INNER") }}
                    </mat-radio-button>
                </mat-radio-group>
                <mat-icon
                    (click)="triggerStatics()"
                    class="sen-fs14 ml-3 sen-cursor-pointer"
                    color="primary"
                >
                    info</mat-icon
                >
            </td>
        </tr>
    </table>
    <p class="mb-1 sen-fs08" *ngIf="!panelFillAll">
        {{ translate.getLng("PNL_FILL_INNER_INFO") }}
    </p>
    <div
        class="text-danger text-right pr-3 mt-1 sen-fs10"
        *ngIf="showThicknessError"
    >
        <!-- {{ "Panel Thickness can't be greater than 30mm for SOL-30 mounting system."}} -->
        {{ translate.getLng("PANEL_THICKNESS_ERROR") }}
    </div>
    <hr class="m-0" />
    <div
        class="w-75 float-right mt-2"
        fxLayout="row"
        fxLayoutAlign="flex-end center"
    >
        <button mat-raised-button class="w-25 py-1" (click)="onNoClick()">
            {{ translate.getLng("CANCEL") }}
        </button>
        <button
            (click)="onOKClick()"
            mat-raised-button
            color="primary"
            class="w-25 py-1 ml-3"
        >
            {{ translate.getLng("OK") }}
        </button>
    </div>
</section>
